import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { House, Microphone, UsersThree, HandsClapping } from '@phosphor-icons/react';

const navItems = [
  { to: '/', key: 'nav.home' as const, icon: House },
  { to: '/episodes', key: 'nav.episodes' as const, icon: Microphone },
  { to: '/about', key: 'nav.about' as const, icon: UsersThree },
  { to: '/community', key: 'nav.community' as const, icon: HandsClapping },
];

export function MobileBottomNav() {
  const { t } = useTranslation();

  return (
    <nav role="navigation" className="md:hidden fixed bottom-0 left-0 w-full h-24 bg-surface-container-high/90 backdrop-blur-2xl z-50 flex justify-around items-center px-2 border-t border-tertiary/10 shadow-[0_-10px_40px_rgba(0,0,0,0.3)]">
      {navItems.map(({ to, key, icon: NavIcon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-1 transition-opacity focus-visible:ring-2 focus-visible:ring-tertiary focus-visible:ring-offset-2 focus-visible:outline-none focus-visible:rounded ${
              isActive
                ? 'text-tertiary font-bold'
                : 'text-on-surface-variant opacity-60 hover:opacity-100'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <NavIcon size={24} weight={isActive ? 'fill' : 'regular'} />
              <span className="font-sans text-xs uppercase tracking-widest">
                {t(key)}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
